var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"card"},[_c('v-card-text',{staticClass:"pa-1"},[_c('area-chart',{attrs:{"data":_vm.data,"dataset":{borderWidth: 3},"colors":['#b00'],"ytitle":"Earnings"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }